import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import styles from '../../styles/login/rightSection.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from "../../utils/useSnackbar";
import LoginForm from './components/LoginForm';
import ForgotPasswordForm from './components/ForgotPasswordForm';
import MfaOtpForm from './components/MfaOtpForm';
import DEFAULT_ROUTES from '../../constants/routes';
import { clearMfaPending } from '../../features/auth/authSlice';

const LOGIN_VIEWS = {
  LOGIN: 'login',
  FORGOT_PASSWORD: 'forgot-password',
  MFA: 'mfa',
};

export default function RightSection() {
    const { user, error=null, mfaPending, mfaEmailHint } = useSelector((state) => state.auth);
    const [currentView, setCurrentView] = useState(LOGIN_VIEWS.LOGIN);
    // Keep MFA UI after verify succeeds until this page unmounts on navigate —
    // otherwise clearMfaPending briefly falls back to the password form.
    const [holdMfaView, setHoldMfaView] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        if (mfaPending) {
            setHoldMfaView(true);
        }
        if (!mfaPending && !user) {
            setHoldMfaView(false);
        }
    }, [mfaPending, user]);

    useEffect(() => {
        if (user) {
          navigate('/home');
        }
      }, [user, navigate]);

    useEffect(() => {
        if (error && error.length > 0) {
            showSnackbar(error, 'error');
        }
    }, [error]);
    
    const handleForgotPassword = () => {
        setCurrentView(LOGIN_VIEWS.FORGOT_PASSWORD);
    };

    const handleBackToLogin = () => {
        setCurrentView(LOGIN_VIEWS.LOGIN);
    };

    const handleBackFromMfa = () => {
        dispatch(clearMfaPending());
        setHoldMfaView(false);
        setCurrentView(LOGIN_VIEWS.LOGIN);
    };

    const activeView = (mfaPending || holdMfaView) ? LOGIN_VIEWS.MFA : currentView;

    return (
        <Box
            className={styles['right-section-container']}
        >
            <Box className={styles['content-wrapper']}>
                <Box
                    className={styles['branding-section']}
                >
                    <Box
                        className={styles['branding-logo']}
                    >
                        <img
                            src={require('../../assets/images/APLogo.svg').default}
                            alt="QA-Path Logo"
                            className={styles['branding-logo-image']}
                        />
                    </Box>
                    <h3
                        className={styles['branding-title']}
                    >
                        QA-Path
                    </h3>
                    <h6
                        className={styles['branding-subtitle']}
                    >
                        Modern AI Enabled Testing Applications
                    </h6>
                </Box>
                <Paper
                    elevation={0}
                    className={styles['form-container']}
                >
                    {activeView === LOGIN_VIEWS.LOGIN && (
                        <LoginForm onForgotPassword={handleForgotPassword} />
                    )}
                    {activeView === LOGIN_VIEWS.FORGOT_PASSWORD && (
                        <ForgotPasswordForm onBack={handleBackToLogin} />
                    )}
                    {activeView === LOGIN_VIEWS.MFA && (
                        <MfaOtpForm
                            onBack={handleBackFromMfa}
                            emailHint={mfaEmailHint}
                        />
                    )}
                    
                    {activeView === LOGIN_VIEWS.LOGIN && (
                        <Box className={styles['footer-section']}>
                            <p className={styles['footer-text']}>
                                Don't have an account?{' '}
                                <Link
                                    to={DEFAULT_ROUTES.SIGNUP}
                                    className={styles['footer-link']}
                                    style={{ textDecoration: 'none' }}
                                >
                                    Sign up
                                </Link>
                            </p>
                        </Box>
                    )}
                </Paper>
            </Box>
        </Box>
    );
}